<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<app-header-card [title]="'Approve Party Pics'">
  <div class="buttons-container">
    <button mat-raised-button color="primary" [routerLink]="'..'">Back to Overview</button>
    <button mat-flat-button color="primary" (click)="openCopyPublicLinkDialog()">
      Public gallery
      <mat-icon>share</mat-icon>
    </button>
  </div>
</app-header-card>

<div>
  <mat-card class="selector">
    <mat-form-field class="select">
      <mat-label>Type of Picture</mat-label>
      <mat-select [(value)]="selectedState" (selectionChange)="fetchPictures()">
        @for (type of pictureStates; track type) {
          <mat-option [value]="type">{{ type }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-card>
  <div class="picture-grid">
    @for (picture of getPictures(); track picture) {
      <app-party-picture-card
        [picture]="picture"
        (pictureStateChanged)="fetchPictures()"
      ></app-party-picture-card>
    }
  </div>
</div>
